/** Shared helpers for rendering CMS content on public pages. */

export const API = `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "")}/api`;

/**
 * pickContent — translation-aware field picker. A CMS record has one
 * primary language plus an optional single translation slot (used by the
 * migrated EN/NL essays). Returns the translation when it matches the
 * visitor's language, otherwise the primary fields.
 */
export function pickContent(item, lang) {
    if (!item) return { title: "", subtitle: "", body: "" };
    const tr = item.translation && item.translation.language === lang ? item.translation : null;
    return {
        title: (tr && tr.title) || item.title || "",
        subtitle: (tr && tr.subtitle) ?? item.subtitle ?? "",
        body: (tr && tr.body) || item.body || "",
    };
}

/** Plain-text body → paragraphs (blank line = new paragraph). */
export function splitParagraphs(text) {
    return String(text || "").split(/\n\n+/).map((p) => p.trim()).filter(Boolean);
}

/** Newest unnumbered items first; the numbered editorial series keeps order. */
export function sortContent(items) {
    const unnumbered = items
        .filter((i) => !i.number)
        .sort((a, b) => String(b.published_at || "").localeCompare(String(a.published_at || "")));
    const numbered = items
        .filter((i) => i.number)
        .sort((a, b) => String(a.number).localeCompare(String(b.number), undefined, { numeric: true }));
    return [...unnumbered, ...numbered];
}

export function fileUrl(path, previewToken = null) {
    const base = `${API}/files/${path}`;
    return previewToken ? `${base}?pt=${encodeURIComponent(previewToken)}` : base;
}
